// extracted by mini-css-extract-plugin
export default {"accordionHeader":"wYjyKGB7nec42_7v6YZr","completionPill":"g89glAK9AXY_3aB5DaoE","headerIcon":"iXwQW6HQCIJbZ1goLpEp","open":"E04JL_2uX23AgWT2qEFh","borderless":"N11COI7bCtDE4ySEm_Fh"};